import React from "react";
import {
  Card,
  CardContent,
  Typography,
   Box,
} from "@mui/material";

import { decrypt } from "../../components/cryptoUtil";
import { Heading } from "../componenet/heading";

export default function NewAdmission() {
  let decryptedData = {};
  try {
    const tokenData = localStorage.getItem("tokenData");
    decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  } catch (e) {
    console.warn("Failed to decrypt tokenData", e);
    decryptedData = {};
  }
  const token = localStorage.getItem("token") || "";
  const hospitalId = decryptedData.softsubgroup || "";

  return (
   <>
   <Heading headingtext="🏥 New Admission" />
   </>
  );
}
